import moment from 'moment';
// Locales must ride the bundle statically: a dynamic require('moment/locale/' + code) cannot
// be resolved at build time by vite/rollup and throws in the browser. These are the ESM
// dist/locale files - each imports '../moment', the SAME file vite resolves for bare 'moment',
// so they register on the instance the app actually uses (the CJS moment/locale/* files bind a
// second instance and need an alias that proved boot-unsafe). The list mirrors
// apps/bringg-web/scripts/supported-languages.mjs (en/en-us are moment built-ins; 'vi' covers
// vi-vn via moment's parent-locale fallback; 'tl' has no moment locale - English, as before).
// Adding a language? Add its dist/locale import here too.
import 'moment/dist/locale/ar';
import 'moment/dist/locale/bg';
import 'moment/dist/locale/da';
import 'moment/dist/locale/de';
import 'moment/dist/locale/el';
import 'moment/dist/locale/en-au';
import 'moment/dist/locale/en-ca';
import 'moment/dist/locale/en-gb';
import 'moment/dist/locale/es';
import 'moment/dist/locale/fi';
import 'moment/dist/locale/fr';
import 'moment/dist/locale/he';
import 'moment/dist/locale/id';
import 'moment/dist/locale/it';
import 'moment/dist/locale/km';
import 'moment/dist/locale/pl';
import 'moment/dist/locale/pt';
import 'moment/dist/locale/pt-br';
import 'moment/dist/locale/ro';
import 'moment/dist/locale/ru';
import 'moment/dist/locale/se';
import 'moment/dist/locale/th';
import 'moment/dist/locale/tr';
import 'moment/dist/locale/vi';
import { isNumber } from 'lodash';

// Every locale file's defineLocale() also switches moment's GLOBAL locale, so after the imports
// above it is left on the last one ('vi'). Restore the default: users with no language never
// call initMomentLocale, and moments created at module load would otherwise format in Vietnamese.
moment.locale('en');

export class LocaleService {
	initMomentLocale(languageCode: string, firstDayOfWeek?: number) {
		if (!isNumber(firstDayOfWeek)) {
			moment.locale(languageCode);
		} else {
			moment.updateLocale(languageCode, {
				week: {
					dow: firstDayOfWeek,
					//This can be different per localization, but the value doesn't really matter.
					//This value means that the first week of the year will be the week that includes Jan 1st.
					doy: firstDayOfWeek + 6
				}
			});
		}
	}
}
